var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subscription"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M149.898 168.26C149.791 170.119 148.422 171.348 147.579 171.934C146.611 172.606 145.31 174.189 145.392 176.164L145.977 181.923C146.069 182.842 145.348 183.641 144.429 183.641L124.523 183.67C123.536 183.67 122.79 182.765 122.994 181.792L123.763 178.061C123.981 176.885 123.681 175.68 122.945 174.741C118.788 169.456 114.34 164.069 114.277 157.25C114.277 157.25 114.214 153.906 115.991 152.522C115.991 152.522 121.276 149.758 121.276 148.461V125.961C121.276 124.596 122.272 123.362 123.632 123.241C125.171 123.101 126.469 124.316 126.469 125.826V131.837C126.469 136.033 128.782 139.841 132.499 141.782L146.432 149.042C148.576 150.16 149.902 152.352 149.902 154.767V168.255L149.898 168.26Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M147.042 149.26H160.182C162.408 149.26 164.209 147.459 164.209 145.233V77.0267C164.209 74.8004 162.408 73 160.182 73H96.0267C93.8004 73 92 74.8004 92 77.0267V145.233C92 147.459 93.8004 149.26 96.0267 149.26H120.835",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M128.622 98.544C132.541 98.544 135.717 95.3674 135.717 91.449C135.717 87.5305 132.541 84.3539 128.622 84.3539C124.704 84.3539 121.527 87.5305 121.527 91.449C121.527 95.3674 124.704 98.544 128.622 98.544Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M112.095 117.201C113.813 109.066 120.559 102.997 128.622 102.997C136.685 102.997 143.432 109.066 145.15 117.201",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M133.071 111.686H126.424C124.532 111.686 123 113.218 123 115.111V115.748C123 117.641 124.532 119.172 126.424 119.172H132.14C134.033 119.172 135.565 120.704 135.565 122.597V123.222C135.565 125.115 134.033 126.646 132.14 126.646H125.493",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M129.279 131.271V125.997",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M129.279 112.275V107",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.f95686679c52833ba2a3a5842c8cad4f.svg";
export { ForwardRef as ReactComponent };